import React from 'react';
import { IDirectoryEntry } from 'services/CrmApi/types/DirectoryEntry';
import { Link } from 'ui/Link';
import { isContactProfile } from 'containers/CRM/helpers';
import { UserDate } from 'containers/CRM/components/UserDate/UserDate';

export interface IContactMainInfoRightPartProps {
  directoryEntry?: IDirectoryEntry;
}

export const ContactMainInfoRightPart: React.FC<IContactMainInfoRightPartProps> = ({ 
  directoryEntry
}) => {
  if (!directoryEntry?.profile || !isContactProfile(directoryEntry?.profile)) {
    return null;
  }

  const isPublished = !!directoryEntry?.publishedDate;

  if (!isPublished) {
    return null;
  }
  
  const linkMapping = {
    'TA': `/travel-agents/${directoryEntry.beId}/edit`,
  };
  const link = linkMapping[directoryEntry?.profile.contactType.code];

  return (
    <div className="absolute right-0 flex flex-col text-right items-end gap-[5px]">
      {directoryEntry.beHumanReadableId && (
        <p className="be-humaid font-pt-sans text-gray-100 text-[13px] m-0">
          <span className="font-[700]">#</span>&nbsp;{directoryEntry.beHumanReadableId}
        </p>
      )}
      <UserDate position="vertical" text="Published by:" date={directoryEntry?.publishedDate} user={directoryEntry?.publishedBy} />
      {link && (
        <Link
          to={link}
          internalClassName="font-pt-sans text-brown-100 text-[15px] font-[700] underline"
          target="_blank"
        >View Settings</Link>
      )}
    </div>
  );
}
